import $ from 'jquery';

$('#printPage').click(function (e) {
  e.preventDefault();

  window.print();
});
